import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CancelProjectWidget from '../../../widgets/closeProject/CancelProjectWidget'
import CancelProjectHistoryWidget from '../../../widgets/closeProject/CancelProjectHistoryWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getCancelForm } from '../../../redux/actions/cancelOfProject'

export default function CancelProjectHighDirector(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getCancelForm(proposalId)
      if (response.success) setSchemas(response.model)
      // setSchemas(mockSchema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}

        {/* {schemas?.forms?.requestNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              isLawyer={true}
              fileList={schemas.forms.fileList}
              attachmentSchema={schemas.forms.attachment}
              requestStep={schemas.forms.requestNote.requestStep}
            />
            <br />
          </>
        )} */}

        {schemas?.forms?.requestNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              //isLawyer={true}
              fileList={schemas.forms.fileList}
              attachmentSchema={schemas.forms.attachment}
              //requestStep={schemas.forms.requestNote.requestStep}
              hideUpload={true}
              isDirector={true}
            />
            <br />
          </>
        )}

        {/* {schemas?.forms?.saveCancelProjectNote && (
          <>
            <CancelProjectWidget
              showCommandButton={!schemas.forms.saveCancelProjectNote.disabled}
              schema={schemas.forms.saveCancelProjectNote}
              attachmentSchema={schemas.forms.attachment}
            />
            <br />
          </>
        )} */}

        {schemas?.forms?.cancelProjectHistory && (
          <>
            <CancelProjectHistoryWidget
              data={schemas.forms.cancelProjectHistory.value}
              header={schemas.forms.cancelProjectHistory.header}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'ยกเลิกการให้ทุนสนับสนุนโครงการ mock',
  subHeader: 'โครงการ เด็กฉลาด ทดสอบทั้งหมด 1',
  disabled: false,
  forms: {
    agreementDetails: {
      title: 'เหตุผลในการยกเลิกการให้ทุนสนับสนุนโครงการ',
      content: 'ขอยกเลิกโครงการ',
      datetime: {
        dateLabel: 'วันที่ : ',
        dateValue: '22 ธันวาคม 2564',
        timeLabel: 'เวลา : ',
        timeValue: '03:02',
      },
      status: {
        statusLabel: 'สถานะ : ',
        statusValue: 'รอพิจารณายกเลิกโครงการ',
      },
    },
    requestNote: {
      header: 'ยกเลิกการให้ทุนสนับสนุนโครงการ',
      buttonText: 'บันทึกผลการพิจารณา',
      buttonText2: null,
      requestStep: 'RequestSummary',
      note: {
        name: 'Note',
        label: 'หมายเหตุ',
        value: null,
        hint: 'ระบุหมายเหตุ',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'โปรดระบุ หมายเหตุ',
          },
        ],
      },
      approveType: {
        options: [
          {
            disabled: false,
            label: 'เห็นชอบ',
            value: 1,
          },
          {
            disabled: false,
            label: 'ไม่เห็นชอบ',
            value: 2,
          },
        ],
        name: 'approveType',
        label: null,
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาระบุ ผลการพิจารณา',
          },
        ],
      },
    },
    attachment: {
      name: 'Attachments',
      label: 'เอกสารแนบประกอบการพิจารณา',
      value: null,
    },
    fileList: [
      {
        fileType: 'Request',
        numberOfSequence: 1,
        label: 'เอกสารประกอบการเสนอพิจารณา',
        name: 'เอกสารประกอบการเสนอพิจารณา',
        path: 'progress/suspended/BD032CD9-3433-4A23-BB06-DAE2EB4D254F.png',
        type: null,
        size: 0,
        id: '5C6839EB-5072-4512-AC35-4A4E73D1C5B7',
      },
    ],
    cancelProjectHistory: {
      header: 'ประวัติการยกเลิกการให้ทุนสนับสนุนโครงการ',
      value: null,
    },
  },
}
